import { createTheme } from '@mui/material';
import { toNumber } from 'lodash';
import overrides from './overrides';
import palette from './palette';
import { ITheme, IThemeOptions } from './types';
import typography from './typography';

export const NAVIGATION_BAR_HEIGHT = '48';
export const PROGRESS_BAR_HEIGHT = '4';
export const TOOLBAR_HEIGHT = '100';

export const SIDEBAR_CLOSED_WIDTH = 60;

export const HEADER_HEIGHT =
  toNumber(TOOLBAR_HEIGHT) + toNumber(NAVIGATION_BAR_HEIGHT) + toNumber(PROGRESS_BAR_HEIGHT);

export const FIXED_HEADER_STYLES = Object.freeze({
  left: `${SIDEBAR_CLOSED_WIDTH}px`,
  top: `calc(${HEADER_HEIGHT}px - ${PROGRESS_BAR_HEIGHT}px)`,
  width: `calc(100% - ${SIDEBAR_CLOSED_WIDTH}px)`,
});

export const themeOptions: IThemeOptions = Object.freeze({
  cellPadding: 5,
  overrides,
  palette,
  typography,
  zIndex: {
    appBar: 1200,
    drawer: 1300,
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: palette.secondary[500],
          },
        },
      },
    },
  },
});

const theme = createTheme(themeOptions) as unknown as ITheme;

export default theme;
